import type { GlobalEventProperties } from "@v2/features/infra/analytics/events";

import * as React from "react";

import { useCurrentProjectContext } from "@v2/contexts/CurrentProjectContext";
import { useCurrentWorkspaceId } from "@v2/contexts/WorkspaceDashboardContext";
import { getStoreData } from "@v2/utils/project-utils";
import { useSearchParams } from "react-router-dom";

type V2AnalyticsGetter = () => Partial<GlobalEventProperties>;

export const useV2AnalyticsGetter = (): V2AnalyticsGetter => {
  const { project, projectId } = useCurrentProjectContext();
  const workspaceId = useCurrentWorkspaceId();
  const [searchParams] = useSearchParams();

  return React.useCallback((): Partial<GlobalEventProperties> => {
    return {
      projectId: projectId ?? null,
      workspaceId: workspaceId ?? null,
      storeUrl: getStoreData(project)?.shopifyUrl,
      chatId: searchParams.get("chatId") ?? null,
      pageId: searchParams.get("pageId") ?? null,
    };
  }, [project, projectId, workspaceId, searchParams]);
};
